<template>
    <div v-if="bindings.length" class="space-y-0.5 px-3 py-2 text-[11px] text-slate-400">
        <div class="flex items-center justify-between gap-2">
            <span class="font-semibold uppercase tracking-wide text-slate-300">From the Logic view</span>
            <button class="text-cyan-300 hover:underline" title="Show the Logic view" @click="logic.setVisible(true)">Show logic</button>
        </div>
        <div v-for="(binding, index) in bindings" :key="index" class="font-mono text-slate-300">
            {{ binding.entity }}.{{ binding.property }} → {{ binding.target_property }}
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useLogicStore } from '../../stores/logicStore.js';
import { useUndoStore } from '../../history/undoStore.js';
import { getLogicGpioStateBindings } from '../../logic/pageLogic.js';

/** GPIO State Bindings of an object that come from GPIO binding nodes; they export next to its own. */
const props = defineProps({
    node: { type: Object, required: true },
});
const logic = useLogicStore();
const undo = useUndoStore();

const bindings = computed(() => {
    // page.logic is plain data outside Vue; these counters say when it changed.
    logic.revision;
    undo.historyVersion;
    return getLogicGpioStateBindings(props.node);
});
</script>
